import React from "react";
import cn from "classnames";
import styles from "./Program.module.sass";
import { Link } from "react-router-dom";

const FonctionnalitesContrat = () => {
  return (
    <div className={cn("section-bg", styles.book)}>
      {/* Conteneur d'image qui s'étend sur le côté droit de l'écran */}
      <div className={styles.imageContainer}>
        <img
          src="/images/content/image-60.png"
          alt="Interface de gestion des absences"
          className={styles.mainImage}
        />
      </div>
      <div className={cn("section-bg", styles.section)}>
        <div className={cn("container", styles.container)}>
          {/* Left side - Text content */}
          <div className={styles.textContent}>
            <h2 className={styles.title}>
              Des fonctionnalités conçues pour vous faire gagner du temps
            </h2>
            <div className={styles.features}>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span><strong>Signature électronique qualifiée :</strong> Faites signer tous vos documents en ligne (contrats, conventions...) avec une valeur juridique reconnue.</span>
              </div>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span><strong>Workflows de validation :</strong> Automatisez la circulation des documents et programmez des relances automatiques pour les fichiers manquants.</span>
              </div>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span><strong>Classement et recherche intelligente :</strong> Chaque document est automatiquement classé. Retrouvez n'importe quel fichier en quelques secondes.</span>
              </div>
              <div className={styles.feature}>
                <div className={styles.checkIcon}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span><strong>Archivage sécurisé et conforme :</strong> Vos données sont chiffrées, hébergées en France et archivées selon les durées légales pour une conformité RGPD totale.</span>
              </div>
            </div>
            <div className={styles.cta}>
              <Link className={cn("button", styles.button)} to="/contact">
                Profiter d'un essai gratuit
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FonctionnalitesContrat;
